import React from 'react';
import NewspaperIcon from '@heroicons/react/outline/NewspaperIcon.js';
import { PostListOrderByEnum } from '@tribeplatform/gql-client/types';
import { BlockType } from '../../types/index.js';
import { PostListBlock as Component } from './Block.js';
import { PostListBlockSettings as Settings } from './Settings.js';
export const RegisteredPostListBlock = (intl) => {
    const { $t } = intl;
    return {
        recommendedName: 'PostList',
        Component,
        config: {
            type: BlockType.Block,
            displayName: $t({
                id: 'Blocks.PostList.DisplayName',
                defaultMessage: 'Post List',
            }),
            deprecated: true,
            Settings,
            Icon: React.createElement(NewspaperIcon, null),
            defaultProps: {
                view: 'card',
                orderBy: PostListOrderByEnum.publishedAt,
            },
        },
    };
};
//# sourceMappingURL=registered.js.map